//#region src/redux/transient/initial-state.ts
var transientInitialState = {
	transients: [],
	isPending: false,
	isRejected: false,
	errorMessage: ""
};
//#endregion
export { transientInitialState };

//# sourceMappingURL=initial-state.js.map